import { get, keys } from 'lodash';
import { Storage } from '@/utils';
import * as en from './en';
import * as fr from './fr';

export default new class Lang {
  constructor() {
    this.langs = { en, fr };
    this.default = 'en';
    this.locale = Storage.get('lang') || this.default;
  }

  isValid(locale) {
    return keys(this.langs).includes(locale);
  }

  setLang(locale) {
    if (!this.isValid(locale)) return;
    Storage.set('lang', locale);
    this.locale = locale;
  }

  getLang() {
    return this.locale;
  }

  translate(path, scope) {
    return scope !== 'LVMH'
      ? get(this.langs, `${this.locale}.${path}`) || ''
      : get(this.langs, `${this.default}.${path}`) || '';
  }
}();
